import React from "react";
import RecognitionPage from "../shared/recognition/RecognitionPage";
import {
  INITIAL_PROJECT_SETTINGS,
  INITIAL_RECOGNITIONS,
  REVENUE_DATA,
} from "./mock/revenueMock";

const REVENUE_CONFIG = {
  periodBy: "project",
  themeClass: "rr-theme--revenue",
  documentPrefix: "ПВ",
  entry: {
    debit: "Неактивированная дебиторская задолженность",
    credit: "Выручка",
  },
  texts: {
    noun: "Выручка",
    nounGenitive: "выручки",
    settingsTab: "Настройки проектов",
    totalLabel: "Итого выручки за период",
    detailsCaption: "Признание выручки",
    formTitle: "Создание признания выручки",
    calcTitle: "Расчет выручки",
    submit: "Признать выручку",
    confirmTitle: "Признать выручку?",
    toastTitle: "Выручка признана",
    note:
      "После подтверждения система сформирует управленческую операцию признания выручки и отразит её в Журнале операций.",
  },
};

function RevenueRecognition() {
  return (
    <RecognitionPage
      config={REVENUE_CONFIG}
      data={REVENUE_DATA}
      initialRecognitions={INITIAL_RECOGNITIONS}
      initialSettings={INITIAL_PROJECT_SETTINGS}
    />
  );
}

export default RevenueRecognition;
